export type DetectionClass = 'person' | 'ball';

export interface DetectionBox {
  class: DetectionClass;
  x: number;
  y: number;
  w: number;
  h: number;
  score: number;
}

export interface DetectionResult {
  detections: DetectionBox[];
  inferenceTimeMs: number;
}

export type DetectorSource = HTMLVideoElement | HTMLCanvasElement;

export interface Detector {
  readonly id: string;
  readonly label: string;
  initialize(): Promise<void>;
  detect(source: DetectorSource): Promise<DetectionResult>;
  dispose(): void;
}

export function boxCenter(box: Pick<DetectionBox, 'x' | 'y' | 'w' | 'h'>): {
  x: number;
  y: number;
} {
  return { x: box.x + box.w / 2, y: box.y + box.h / 2 };
}

export function boxArea(box: Pick<DetectionBox, 'w' | 'h'>): number {
  return Math.max(0, box.w) * Math.max(0, box.h);
}

export function boxIoU(
  a: Pick<DetectionBox, 'x' | 'y' | 'w' | 'h'>,
  b: Pick<DetectionBox, 'x' | 'y' | 'w' | 'h'>,
): number {
  const x1 = Math.max(a.x, b.x);
  const y1 = Math.max(a.y, b.y);
  const x2 = Math.min(a.x + a.w, b.x + b.w);
  const y2 = Math.min(a.y + a.h, b.y + b.h);
  const interW = Math.max(0, x2 - x1);
  const interH = Math.max(0, y2 - y1);
  const inter = interW * interH;
  if (inter <= 0) return 0;
  const union = boxArea(a) + boxArea(b) - inter;
  return union <= 0 ? 0 : inter / union;
}
